import type { jsPDF } from "jspdf";
import { Box } from "../layout/box.ts";
import { Margin } from "../layout/margin.ts";
import { Position } from "../layout/position.ts";
import { Size } from "../layout/size.ts";
import { BaseElement } from "./baseElement";

export class FixedContainer extends BaseElement {
	kind = "fixed" as const;
	fixedBox: Box;

	constructor(box: Box, id: string) {
		super(box, id);
		this.fixedBox = new Box(
			new Position(box.position.x, box.position.y),
			new Size(box.size.width, box.size.height),
			new Margin(box.margin.left, box.margin.right, box.margin.top, box.margin.bottom)
		);
	}

	async calculate(jsPdf: jsPDF) {
		this.box.position = this.fixedBox.position;
		const boundingBox = this.box.getBoundingBox();
		let cursorY = boundingBox.y;
		let totalHeight = 0;
		for (const child of this.children) {
			child.box.position.x = boundingBox.x;
			child.box.position.y = cursorY;
			await child.calculate(jsPdf);
			const childBoundingBox = child.box.getBoundingBox();
			cursorY += childBoundingBox.outerHeight;
			totalHeight += childBoundingBox.outerHeight;
		}
		this.box.size.height = totalHeight;
	}

	override async draw(pdfDocument: jsPDF): Promise<void> {
		for (const child of this.children) {
			await child.draw(pdfDocument);
		}
	}
}
